import React, { useEffect, useState } from 'react'
import { articlesApi } from '../../../../api/articlesApi'
import { getUrlFromAStream } from '../../../../utils/getUrlByFileStream'
import { swalTitle } from '../../../../constantes/swalTitle'
import {
  swalAlertError,
  swalAlertIsConfirm,
  swalSuccessGeneral,
  swalLoading,
} from '../../../../utils/swalAlert'
import Swal from 'sweetalert2'
import ProductImagegesAndVideo from '../productsAuxForm/ProductImagegesAndVideo'
// import DeleteBtn from '../../../buttons/DeleteBtn'
import { Form } from 'react-bootstrap'
import _ from 'lodash'

const EditProductImagsAndVideo = ({
  id,
  inputs,
  handleChange,
  IsChangeLinkVideo,
  thereuploadFiles,
  refreshProductInfo,
}) => {
  const [coverImage, setCoverImage] = useState('')
  const [images, setImages] = useState([])
  const [newCoverImage, setNewCoverImage] = useState('')
  const [newImages, setNewImages] = useState([])
  //Estado para limpiar los UploadFile, no me sirve en para newDocs, hay actualizarlo a mano, setNewDocs([])
  const [reload, setReload] = useState(false)

  useEffect(() => {
    getCoverimg(id)
    getAllImgs(id)
  }, [])

  useEffect(() => {
    thereuploadFiles(newCoverImage)
    thereuploadFiles(newImages)
  }, [newCoverImage, newImages])

  const getCoverimg = async (idArticle) => {
    const resp = await articlesApi.getArticleCoverImg(idArticle)
    if (resp.data) {
      await getCoverImgProduct(resp.data)
    }
  }

  const getCoverImgProduct = async (response) => {
    let getCoverimg = response
    if (!_.isEmpty(getCoverimg)) {
      // Esto ayudaria si quieren ver la imagen
      getCoverimg.ruta = await getUrlFromAStream(
        getCoverimg.ruta,
        'application/imagen',
      )
      setCoverImage(getCoverimg)
    }
  }

  const getAllImgs = async (idArticle) => {
    const resp = await articlesApi.getArticleImgs(idArticle)
    if (resp.data.length > 0) {
      await getImagesProduct(resp.data)
    }
  }

  const getImagesProduct = async (resp) => {
    const getImages = resp
    for (let img in getImages) {
      getImages[img].ruta = await getUrlFromAStream(
        getImages[img].ruta,
        'application/image',
      )
      setImages(getImages)
    }
  }

  //********************** Guardar las imagenes y el link (en caso de ser modificado) del Articulo
  const handleSubmitArticleImags = async () => {
    try {
      const operations = [
        ...(IsChangeLinkVideo ? [articlesApi.updateArticles(inputs)] : []),
        ...(!_.isEmpty(newCoverImage) ? [saveCoverImagen(id)] : []),
        ...(!_.isEmpty(newImages) ? [saveImages(id)] : []),
      ]

      if (operations.length > 0) {
        const responses = await Promise.all(operations)
        const lastResponse = responses[responses.length - 1]

        // Actualizar estados después de guardar
        if (!_.isEmpty(newCoverImage)) {
          await getCoverimg(id)
          setNewCoverImage('')
        }
        if (!_.isEmpty(newImages)) {
          await getAllImgs(id)
          setNewImages([])
        }

        if (typeof refreshProductInfo === 'function') {
          await refreshProductInfo()
        }

        if (lastResponse && lastResponse.status === 200) {
          await swalSuccessGeneral(swalTitle.Actualizado, lastResponse.data)
          setReload((prev) => !prev)
        } else {
          swalAlertError('Error al guardar los cambios')
        }
      }
    } catch (error) {
      swalAlertError(
        'Error al procesar las imágenes: ' +
          (error.response && error.response.data
            ? error.response.data
            : error.message),
      )
    }
  }

  const saveCoverImagen = async (idArticle) => {
    try {
      const formData = new FormData()
      formData.append('files[]', newCoverImage)
      formData.append('IsImagenPortada', true)
      formData.append('id_Articulo', idArticle)
      const response = await articlesApi.uploadFiles(formData)
      return response
    } catch (error) {
      swalAlertError(
        'Error con la imagen de portada' + error.response.data ||
          error.response.statusText,
      )
    }
  }

  const saveImages = async (idArticle) => {
    try {
      const formData = new FormData()
      newImages.map((img) => {
        formData.append('files[]', img)
      })
      formData.append('id_Articulo', idArticle)
      const response = await articlesApi.uploadFiles(formData)
      return response
    } catch (error) {
      swalAlertError(
        'Error con las imágenes del producto' + error.response.data ||
          error.response.statusText,
      )
    }
  }

  const validButtonSaveArticleImages = () => {
    return (
      IsChangeLinkVideo || !_.isEmpty(newImages) || !_.isEmpty(newCoverImage)
    )
  }

  const handleRemoveArticleDocument = async (event, id_ArticuloDocumento) => {
    event.preventDefault()
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar la imageb del producto?',
      )

      if (alert.isConfirmed) {
        swalLoading(swalTitle.Loading)
        const response = await articlesApi.deleteArticlesDocuments(
          id_ArticuloDocumento,
        )
        setImages(
          images.filter(
            (item) => item.id_ArticuloDocumento != id_ArticuloDocumento,
          ),
        )
        Swal.close()
        swalSuccessGeneral(swalTitle.Eliminado, response.data)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  //********************** Controlar los estados de la subida de archivos
  const uploadCoverImage = (coverImg) => {
    setNewCoverImage(coverImg[0])
  }

  const uploadImages = (imgs) => {
    setNewImages(imgs)
  }

  return (
    <div className='task__container'>
      <h2 className='mb-10 products__subtitle'>Imágenes y vídeo</h2>
      <ProductImagegesAndVideo
        inputs={inputs}
        uploadCoverImage={uploadCoverImage}
        uploadImages={uploadImages}
        handleChange={handleChange}
        reload={reload}
        setReload={setReload}
        refreshProductInfo={refreshProductInfo}
      />
      <button
        className='btn save mb-30'
        disabled={!validButtonSaveArticleImages()}
        onClick={handleSubmitArticleImags}
      >
        Guardar
      </button>
    </div>
  )
}

export default EditProductImagsAndVideo
